import React from 'react';
import { Section, Card } from '../shared/primitives';
import { dosing, epicOrders, pump, blockList, rounding } from '../../../data/hospitals/thiBlocks';

const Confirm = () => (
  <span className="inline-block ml-1.5 align-middle px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">
    confirm
  </span>
);

const Pending = ({ text }) => (
  <div className="px-4 py-4 text-sm text-gray-400 dark:text-gray-500 italic">{text}</div>
);

const NerveBlocks = () => (
  <div className="space-y-6">
    <Section title="Common dosing regimens">
      <Card>
        {dosing.map((d) => (
          <div key={d.block} className="px-4 py-3">
            <div className="text-[15px] font-medium text-gray-900 dark:text-white leading-snug">
              {d.block}{d.confirm && <Confirm />}
            </div>
            <div className="text-sm text-gray-700 dark:text-gray-300 mt-1 leading-snug">{d.regimen}</div>
            {d.note && <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{d.note}</div>}
          </div>
        ))}
      </Card>
    </Section>

    <Section title="Placing orders in Epic">
      <Card>
        {epicOrders.items.map((o) => (
          <div key={o.name} className="px-4 py-3">
            <div className="text-[15px] font-medium text-gray-900 dark:text-white leading-snug">{o.name}</div>
            <div className="text-sm text-gray-400 dark:text-gray-500 italic mt-0.5">{o.detail}</div>
          </div>
        ))}
      </Card>
    </Section>

    <Section title="Setting up the pump">
      <Card>
        <div className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300 leading-snug">{pump.transition}</div>
      </Card>
    </Section>

    <Section title="Adding a patient to the nerve block list">
      <Card><Pending text={blockList.pending} /></Card>
    </Section>

    <Section title="Rounding">
      <Card><Pending text={rounding.pending} /></Card>
    </Section>
  </div>
);

export default NerveBlocks;
